import React from "react";
import ReactDOM from "react-dom/client";
import htmlToDom from "html-react-parser";
const { format } = require("date-fns");
const dateFormat = window.Translator.trans("locale.date.format", {}, "js");

class HistoryPage extends React.Component {
  constructor(props) {
    super(props);
    this.fetchItems = this.fetchItems.bind(this);
    this.removeAll = this.removeAll.bind(this);

    this.state = {
      items: localStorage.getItem("historyItems"),
      loader: true,
      page: "",
      emptyPage: document.querySelector("#emptyPage"),
    };
  }

  removeAll() {
    this.setState({
      page: "",
      items: null,
      found: 0,
      loader: false,
    });
    localStorage.removeItem("historyItems");
    this.state.emptyPage.classList.remove("hidden");
  }

  fetchItems(currentTab) {
    let self = this;
    let url = window.Routing.generate("_history." + lang);
    let requestUrl = window.Routing.generate("_storage_items." + lang, {
      ids:
        self.state.items != null
          ? JSON.parse(self.state.items).map((item) => {
              return item.id;
            })
          : null,
      type: "history",
    });
    fetch(requestUrl)
      .then((response) => response.text())
      .then(
        (result) => {
          self.setState(
            {
              page: result,
              loader: false,
            },
            () => {
              window.mapTrigger();

              if (self.state.page != "") {
                self.state.emptyPage.classList.add("hidden");
              } else {
                self.state.emptyPage.classList.remove("hidden");
              }

              if (currentTab == true) {
                saveRentalNavigationItems(self.state.items, url);
                if ($("#listView").length) {
                  $("#listView .t.i").each(function (index, item) {
                    HistoryHelper.setBookingItemInfo(
                      "history-" + item.getAttribute("id")
                    );
                  });
                }
              }
            }
          );
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          console.log(error);
          self.setState({
            items: null,
            loader: false,
            page: "",
          });
        }
      );
  }

  componentDidMount() {
    let self = this;
    if (this.state.items != null) {
      self.fetchItems(true);
    } else {
      self.setState({
        items: null,
        found: 0,
        loader: false,
        page: "",
      });
      this.state.emptyPage.classList.remove("hidden");
    }
    window.addEventListener("storage", function () {
      if ((localStorage.getItem("historyItems") || "") != self.state.items) {
        self.setState({
          items: localStorage.getItem("historyItems") || null,
          loader: true,
        });
        self.fetchItems(false);
      }
    });
  }

  render() {
    return (
      <>
        {this.state.page.length ? htmlToDom(this.state.page) : ""}
        {/* {this.state.loader ? (
          <div className="ctrl tc mt-5 mb-4">
            <p style={{margin: '0 auto', width: '150px'}}>
              <Loader />
            </p>
          </div>
        ) : (
          ""
        )} */}
      </>
    );
  }
}

let history = document.getElementById("history");
if (window.localStorageSupport && history !== null) {
  const historyRoot = ReactDOM.createRoot(history);
  historyRoot.render(<HistoryPage />);
}

const HistoryHelper = {
  areDatesCurrent: function (booking_dates) {
    let dateSeparator =
      " " + window.Translator.trans("locale.to", {}, "js") + " ";
    let explodedDates = booking_dates.split(dateSeparator);
    let dateFormat = window.Translator.trans("locale.date.format", {}, "js");

    const { parse } = require("date-fns");
    let dateFrom = parse(explodedDates[0], dateFormat, new Date());

    if (dateFrom.getTime() > new Date().getTime()) {
      return true;
    }
    return false;
  },

  loadBookingData: function (parentSelector) {
    let self = this;
    // Check if the form data exists in local storage
    if (window.localStorageSupport && localStorage.getItem("bookingData")) {
      const bookingData = JSON.parse(localStorage.getItem("bookingData"));
      // Prefill the form fields
      if (
        document.getElementById("booking_agreement") != null &&
        bookingData.agreement != null &&
        bookingData.agreement == "1"
      ) {
        document
          .getElementById("booking_agreement")
          .setAttribute("checked", "checked");
      }
      [
        "dates",
        "adults",
        "children",
        "salutation",
        "name",
        "surname",
        "email",
        "phone_country",
        "phone_number",
        "message",
      ].forEach(function (item) {
        let DOMElem = document.getElementById("booking_" + item);
        if (
          DOMElem != null &&
          DOMElem.value === "" &&
          bookingData[item] !== ""
        ) {
          if (item !== "dates" || self.areDatesCurrent(bookingData[item])) {
            if (DOMElem.tagName == "SELECT") {
              if (!DOMElem.classList.contains("do-not-prefill")) {
                for (let index = 0; index < DOMElem.options.length; index++) {
                  if (DOMElem.options[index].value == bookingData[item]) {
                    DOMElem.selectedIndex = index;
                    DOMElem.dispatchEvent(new Event("change"));
                    break;
                  }
                }
              }
            } else if (
              DOMElem.value == "" &&
              !DOMElem.classList.contains("do-not-prefill")
            ) {
              DOMElem.value = bookingData[item] || "";
              DOMElem.dispatchEvent(new Event("change"));
            }
          }

          // Add class to sibling label
          let siblingLabel = DOMElem.nextElementSibling;
          if (
            DOMElem.value !== "" &&
            siblingLabel &&
            siblingLabel.tagName == "LABEL" &&
            siblingLabel.classList.contains("mdc-floating-label")
          ) {
            siblingLabel.classList.add("mdc-floating-label--float-above");
          }
        }
      });

      // $(parentSelector + " label.mdc-floating-label").addClass("mdc-floating-label--float-above");
    }
  },
  saveBookingData: function (itemId) {
    if (window.localStorageSupport) {
      // Listen for form submission
      // Get the form data
      const bookingData = {
        dates: document.getElementById("booking_dates").value || "",
        adults: document.getElementById("booking_adults").value || "",
        children: document.getElementById("booking_children").value || "",
        salutation: document.getElementById("booking_salutation").value || "",
        name: document.getElementById("booking_name").value || "",
        surname: document.getElementById("booking_surname").value || "",
        email: document.getElementById("booking_email").value || "",
        phone_number:
          document.getElementById("booking_phone_number").value || "",
        phone_country:
          document.getElementById("booking_phone_country").value || "",
        message: document.getElementById("booking_message").value || "",
        agreement: document.getElementById("booking_agreement").value || "",
      };

      // Store the form data in local storage
      localStorage.setItem("bookingData", JSON.stringify(bookingData));

      let bookingItems = localStorage.getItem("bookingItems")
        ? JSON.parse(localStorage.getItem("bookingItems"))
        : [];
      bookingItems.forEach(function (item, index) {
        if (item.id == itemId) {
          bookingItems = bookingItems.filter((item) => item.id !== itemId);
        }
      });
      bookingItems.push({ id: itemId, date: new Date().getTime() });
      localStorage.setItem("bookingItems", JSON.stringify(bookingItems));
    }
  },

  saveVisitedItem: function (itemId) {
    if (window.localStorageSupport) {
      let historyItems = localStorage.getItem("historyItems")
        ? JSON.parse(localStorage.getItem("historyItems"))
        : [];
      historyItems.forEach(function (item) {
        if (item.id == itemId) {
          historyItems = historyItems.filter((item) => item.id !== itemId);
        }
      });
      historyItems.push({ id: itemId, date: new Date().getTime() });
      localStorage.setItem("historyItems", JSON.stringify(historyItems));
    }
  },

  isVisitedItem: function (itemId) {
    if (window.localStorageSupport) {
      let historyItems = localStorage.getItem("historyItems")
        ? JSON.parse(localStorage.getItem("historyItems"))
        : [];
      let previousVisit = false;
      historyItems.forEach(function (item) {
        if (item.id == itemId) {
          previousVisit = item;
          return item.date;
        }
      });
      return previousVisit;
    }
    return false;
  },
  setVisitedItemInfo: function (wrapperId) {
    let vhWrap = document.getElementById(wrapperId || "visit-history");
    if (vhWrap !== null && $(vhWrap).text() == "") {
      let visit = false;
      if ((visit = this.isVisitedItem(vhWrap.getAttribute("data-id")))) {
        let lastDate = format(new Date(visit.date), dateFormat);
        vhWrap.innerHTML = window.Translator.trans(
          "visit.history",
          { date: lastDate.toLocaleString() },
          "js"
        );
        vhWrap.classList.remove("hidden");
      }
    }
  },

  isBookingItem: function (itemId) {
    if (window.localStorageSupport) {
      let bookingItems = localStorage.getItem("bookingItems")
        ? JSON.parse(localStorage.getItem("bookingItems"))
        : [];
      let previousBooking = false;
      bookingItems.forEach(function (item) {
        if (itemId == item.id) {
          previousBooking = item;
          return item.date;
        }
      });
      return previousBooking;
    }
    return false;
  },

  setBookingItemInfo: function (wrapperId) {
    let bhWrap = document.getElementById(wrapperId || "booking-history");
    if (bhWrap !== null) {
      let booked = false;
      if ((booked = this.isBookingItem(bhWrap.getAttribute("data-id")))) {
        let lastDate = format(new Date(booked.date), dateFormat);
        bhWrap.innerHTML = window.Translator.trans(
          "booking.history",
          { date: lastDate.toLocaleString() },
          "js"
        );
        bhWrap.classList.remove("hidden");
        return true;
      }
    }
    return false;
  },
};

export default HistoryHelper;
